// linked to https://gitlab.com/c3711/dev-cs1/mad/-/issues/165
import Vue from "vue";
export var LOCALSTORAGE_SUBMENU_KEY = 'submenu';
export function toggleAccordion(index, accordion) {
    var updatedOpenState = !accordion.submenus[index];
    for (var i = 0; i < accordion.submenus.length; i++) {
        if (i === index) {
            Vue.set(accordion.submenus, i, updatedOpenState);
        }
        else {
            Vue.set(accordion.submenus, i, false);
        }
    }
    Vue.set(accordion, 'main', !updatedOpenState);
}
export function emptyAccordion(size) {
    var submenus = [];
    for (var i = 0; i < size; i++) {
        Vue.set(submenus, i, false);
    }
    return {
        main: true,
        submenus: submenus,
    };
}
